<template>
  <v-main :class="{ 'dashboard-main': isDashboardRoute }">
    <div :class="['route-shell', { 'route-shell--dashboard': isDashboardRoute }]">
      <router-view></router-view>
    </div>
    <notification></notification>
  </v-main>
</template>

<script>
    import notification from '@/components/core/Notification.vue';

    export default {
        name: 'DashboardCoreView',
        components: {
            notification
        },
        computed: {
            isDashboardRoute () {
                return this.$route.path.indexOf('/dashboard') > -1
            }
        }
    }
</script>

<style>
html,
body,
#app {
    height: 100%;
}

body {
    margin: 0;
}

.dashboard-main,
.dashboard-main .v-main__wrap {
    height: 100%;
    min-height: 0;
    overflow: hidden;
}

.route-shell--dashboard {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    overflow: hidden;
}

.route-shell--dashboard > * {
    flex: 1 1 auto;
    min-height: 0;
}
</style>
